import * as TAGSORT from '../plugins/tagsort'
import CONTENT_HEADER from '../plugins/content_header'


const init = () => {
  
  CONTENT_HEADER()
  
  TAGSORT.set_config({ perpage: 20,related_perpage: 8 })
  TAGSORT.default({
    template: `
      <div id="main" class="column-3-4">
        <transition-group class="p-list" tag="div" name="fade" mode="out-in">
          <a class="p-item" :href="article.href" v-for="article in pagedArticles" :key="article.id">
            <figure class="p-item__img"><img :src="article.thumb" width="200"></figure>
            <div class="p-item__body">
              <h5 class="p-item__title">{{ article.title }}</h5>
              <div class="p-item__tags" v-if="article.keywords != null">
                <span v-for="keyword in article.keywords" class="button button-xsmall">{{keyword}}</span>
              </div>
            </div>
          </a>
        </transition-group>
        <pagination
          v-if="totalPage > 1"
          :paged="paged"
          :total-page="totalPage"
          :total-item="totalItem"
          :item-count="pagedArticles.length"
          :prevText="'PREV'"
          :nextText="'NEXT'"
          @change="pageChange"
        />
      </div>
    `
  }).then( res => {

    // taglistの作成
    const $tagContainer = $('<div />',{class:'p-taglist align-center'})
    const tagClass = 'class="button button-small"'

    // ALL追加
    $tagContainer.append(`<a href="/projects/?mode=list" ${tagClass}>ALL</a>`)

    // タグリンク追加
    $.each(res.tags, (key,tag) => {
      const is_active = (window.query_string('tag') == key)? 'is-current': ''
      const $taglink = $(`<a href="/projects/?mode=list&tag=${key}" ${tagClass}>${tag}</a>`)
      $tagContainer.append( $taglink.addClass( is_active ) )
    })

    if( document.body.classList.contains('is--detail') ){
      $tagContainer.currentMenu({ default: false, mode: 0 })
    }else{
      $tagContainer.currentMenu({ mode: 0 })
    }

    // タグリストをリスト上部と下部に追加
    // SP一覧: 上下  SP詳細:下
    // PC一覧: 上下  PC詳細:下
    if( $.UA.is_mobile ){
      $('.listContents #main').prepend( $tagContainer ).after( $tagContainer.clone(true) )
      window.load['contentFooter'].done(() => {
        $('.p-contentfooter','.is--detail').before( $tagContainer.clone(true) )
      })
    }else{
      $('#main').prepend( $tagContainer ).append( $tagContainer.clone(true) )
      $('#main .p-taglist:eq(0)','.is--detail').remove()
    }

  })

  // 詳細ページだったらタイトル下にその記事のタグリストを表示
  if( window.query_string('article') ){
    const post_id = window.query_string('article');
    const getTheTags = TAGSORT.get_the_tags( post_id );
    const tagClass = 'class="button button-small"';
    const thisArticle = $.get(`/asset/api/getArticles/`, { content: 'projects', post_id });
    getTheTags.then( res => {
      const $tagContainer = $('<div />',{class:'p-taglist'})
      // タグリンク追加
      $.each( res, ( i, tag ) => {
        const $taglink = $(`<a href="/projects/?mode=list&tag=${encodeURI(tag)}" ${tagClass}>${tag}</a>`)
        $tagContainer.append( $taglink )
      })

      // タグリストをタイトル下に追加
      if( res != null && res.length ) $('.detail_title, .titleTxt').append( $tagContainer )
    })

    // 関連記事を表示
    // $('<div data-plugin="related_articles" />').insertAfter( $.UA.is_mobile ? '.detailFooter': '.element_detail' )
    // TAGSORT.related_articles( {
    //   el: '[data-plugin="related_articles"]'
    // })

    thisArticle.then( article => {
      switch ( parseInt(article[0].category) ){
        case 1: // 不動産開発
          $('body').addClass('is--develop-project');
          break;
      }
    });
    
  }
}

export default function PROJECTS () {
  document.addEventListener( 'DOMContentLoaded', init )
}